import React, { useState, useEffect } from 'react'

function useStickyState(defaultValue, key) {
  const [value, setValue] = useState(() => {
    let stickyValue = null

    if (typeof window !== 'undefined') {
      stickyValue = window.localStorage.getItem(key)
    }

    return stickyValue !== null ? JSON.parse(stickyValue) : defaultValue
  })

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(key, JSON.stringify(value))
    }
  }, [key, value])

  return [value, setValue]
}

export default useStickyState
